import React from "react";
import NewsletterNineteen from "../component/NewsletterNineteen";

function NewsletterNineteenContainer() {
  return <NewsletterNineteen />;
}

export default NewsletterNineteenContainer;
